export const returnUrl = process.env.REACT_APP_BASE_URL+'/account'
export const testHomeworkId = process.env.REACT_APP_TEST_HOMEWORK
export const paymentApiUrl = process.env.REACT_APP_PAYMENT_URL+'/api/v1'
export const homeworkApiUrl = process.env.REACT_APP_HOMEWORK_API_URL
export const accountApiUrl = process.env.REACT_APP_ACCOUNT_API_URL
